import * as React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography } from "@mui/material";

import { isEmpty } from "../../helper-functions/shared/miscUtils";

/**
 * Accordion component with a title and optional description.
 * Will close the previous component if clicked on another one.
 *
 * Required props:
 * values (incl. different key-value pairs)
 */
export default function ControlledAccordion(props) {
    const values = props.values;
    const startClosed = props.startClosed;

    const expand = props?.browser?.expand;
    const setExpand = props?.browser?.setExpand;

    const startExpanded = values.length === 1 && !startClosed ? "0" : false;

    const [expanded, setExpanded] = React.useState(startExpanded);

    React.useEffect(() => {
        setExpanded(startExpanded);
    }, [startExpanded]);

    React.useEffect(() => {
        if (typeof expand !== "boolean") return;

        setExpanded(expand ? "0" : false);
        setExpand(null);
    }, [expand]);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const createComponent = (value, index) => {
        if (isEmpty(value)) return;
        if (value.divider) return <Divider key={index} sx={{ m: 2 }} />;

        return (
            <Accordion
                expanded={expanded === String(index)}
                onChange={handleChange(String(index))}
                key={index}
                sx={{ border: value.borderColor ? `1px solid ${value.borderColor}` : undefined, margin: 0.5 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 60 }} style={{ justifyContent: "space-between" }}>
                    <Typography sx={{ width: "45%", flexShrink: 0, fontWeight: "bold" }}>{value.title ?? ""}</Typography>
                    <Typography sx={{ color: "text.secondary" }}>{value.description ?? ""}</Typography>
                </AccordionSummary>

                <AccordionDetails>{value.component}</AccordionDetails>
            </Accordion>
        );
    };

    return <Box sx={{ m: 1 }}>{values.map((value, index) => createComponent(value, index))}</Box>;
}
